module.exports = __webpack_public_path__ + "static/Fellix-Regular-997d05658ec65cf058627c5711d84918.woff";